import { RoleClaims } from "common/class/claims/role-claims";

export class Claims {
    public static readonly Roles: RoleClaims = new RoleClaims()


}